
export function capitalizeFirstLetter(string) {
    if(string === undefined){
        return "NA";
    }
    else{
        return string?.charAt(0).toUpperCase() + string.slice(1);
    }

}